import { render, staticRenderFns } from "./DetailOrderHistory.vue?vue&type=template&id=73d6dc1a"
import script from "./DetailOrderHistory.vue?vue&type=script&lang=js"
export * from "./DetailOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./DetailOrderHistory.vue?vue&type=style&index=0&id=73d6dc1a&prod&lang=css"
import style1 from "./DetailOrderHistory.vue?vue&type=style&index=1&id=73d6dc1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports